module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1BiuSaU/html/images/cover.jpg?1724432674408",
      "alt": "This image is the cover for the book Economic Approach to Human Behavior"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Economic Approach to Human Behavior\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Since his pioneering application of economic analysis to racial discrimination, Gary S. Becker has shown that an economic approach can provide a unified framework for understanding all human behavior. In a highly readable selection of essays Becker applies this approach to various aspects of human activity, including social interactions; crime and punishment; marriage, fertility, and the family; and \"irrational\" behavior."), _c('br'), _c('br'), _vm._v(" \"Becker's highly regarded work in economics is most notable in the imaginative application of 'the economic approach' to a surprising breadth of human activity. Becker's essays over the years have inevitably inspired a surge of research activity in testimony to the richness of his insights into human activities lying 'outside' the traditionally conceived economic markets. Perhaps no economist in our time has contributed more to expanding the area of interest to economists than Becker, and a number of these thought-provoking essays are collected in this book.\"—"), _c('i', [_vm._v("Choice")]), _c('br'), _c('br'), _vm._v(" Gary Becker was awarded the Nobel Prize in Economic Science in 1992.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Gary S. Becker\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Please fill in author biography")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The University of Chicago Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0